import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { SnAppliance, SnLocationType } from '@lib/api/entities';

@Component({
  selector: 'fs-appliance-dashboard-details',
  templateUrl: './appliance-dashboard-details.component.html',
  styleUrls: ['./appliance-details-section.component.scss'],
})
export class ApplianceDashboardDetailsComponent implements OnChanges {
  /**
   * Full appliance or core details (name, address, passphrase, etc.)
   */
  @Input()
  public appliance: SnAppliance;

  public fullAddress: string;
  public locationType: SnLocationType | string;
  public contactName: string;
  public contactPhone: string;
  public contactEmail: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appliance'] && this.appliance) {
      const { location } = this.appliance;

      this.fullAddress = location?.fullAddress ?? '—';
      this.locationType = location?.type?.name ?? '—';
      this.contactName = location?.contactName ?? '—';
      this.contactPhone = location?.contactPhone ?? '—';
      this.contactEmail = location?.contactEmail ?? '—';
    }
  }
}
